import React, { useRef, useState } from 'react';
import PlacePhotoPicker from './PlacePhotoPicker';

function PhotoUploadSection({
  photoPreview,
  onPhotoChange,
  onRemovePhoto,
  showAlert,
  places = [], // Optional: places from the list to choose photos from
}) {
  const fileInputRef = useRef(null);
  const [showPlacePicker, setShowPlacePicker] = useState(false);

  const handlePhotoClick = () => {
    fileInputRef.current?.click();
  };

  const handleChooseFromPlaces = () => {
    setShowPlacePicker(true);
  };

  const handlePlacePhotoSelect = (photoUrl) => {
    onPhotoChange(photoUrl);
    setShowPlacePicker(false);
  };

  const handlePhotoChange = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      // Validate file type
      if (!file.type.startsWith('image/')) {
        showAlert('Please select an image file', { variant: 'warning' });
        return;
      }
      // Validate file size (max 500KB - Firestore has 1MB doc limit and base64 adds ~33% overhead)
      if (file.size > 500 * 1024) {
        showAlert('Image must be less than 500KB', { variant: 'warning' });
        return;
      }

      const reader = new FileReader();
      reader.onloadend = () => {
        onPhotoChange(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleRemovePhoto = () => {
    onRemovePhoto();
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const hasPlaces = places && places.length > 0;

  return (
    <div className="edit-list-photo-section">
      <input
        type="file"
        ref={fileInputRef}
        onChange={handlePhotoChange}
        accept="image/*"
        style={{ display: 'none' }}
      />
      <div
        className={`edit-list-photo-upload ${photoPreview ? 'has-photo' : ''}`}
        onClick={handlePhotoClick}
      >
        {photoPreview ? (
          <>
            <img src={photoPreview} alt="List cover" className="edit-list-photo-preview" />
            <div className="edit-list-photo-overlay">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/>
                <circle cx="12" cy="13" r="4"/>
              </svg>
              <span>Change Photo</span>
            </div>
          </>
        ) : (
          <div className="edit-list-photo-placeholder">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
              <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/>
              <circle cx="12" cy="13" r="4"/>
            </svg>
            <span>Customize Cover Photo</span>
          </div>
        )}
      </div>

      <div className="edit-list-photo-actions">
        {hasPlaces && (
          <button
            type="button"
            className="edit-list-choose-from-places"
            onClick={handleChooseFromPlaces}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
              <rect x="3" y="3" width="7" height="7" />
              <rect x="14" y="3" width="7" height="7" />
              <rect x="3" y="14" width="7" height="7" />
              <rect x="14" y="14" width="7" height="7" />
            </svg>
            Choose from Places
          </button>
        )}
        {photoPreview && (
          <button type="button" className="edit-list-remove-photo" onClick={handleRemovePhoto}>
            Remove Photo
          </button>
        )}
      </div>

      {showPlacePicker && (
        <PlacePhotoPicker
          places={places}
          onSelectPhoto={handlePlacePhotoSelect}
          onClose={() => setShowPlacePicker(false)}
        />
      )}
    </div>
  );
}

export default PhotoUploadSection;
